﻿import * as mapEventTypes from '../utils/mapEventTypes';
import { isDesktop as isDesktopDevice } from '../utils/utils';
import * as styleTypes from '../utils/style/styleTypes';
import * as eventTypes from '../utils/eventTypes';
import * as layerTypes from '../utils/layerTypes';
import { Image as ImageLayer, Vector as VectorLayer, WebGLVector as WebGLLayer } from 'ol/layer';

import { buffer as getBuffer } from 'ol/extent';
import OL3Parser from 'jsts/org/locationtech/jts/io/OL3Parser.js';


import Point from 'ol/geom/Point.js';
import LineString from 'ol/geom/LineString.js';
import LinearRing from 'ol/geom/LinearRing.js';
import Polygon from 'ol/geom/Polygon.js';
import MultiPoint from 'ol/geom/MultiPoint.js';
import MultiLineString from 'ol/geom/MultiLineString.js';
import MultiPolygon from 'ol/geom/MultiPolygon.js';
import GeometryCollection from 'ol/geom/GeometryCollection.js';
import Circle from 'ol/geom/Circle.js';
import RelateOp from 'jsts/org/locationtech/jts/operation/relate/RelateOp.js';
import BufferOp from 'jsts/org/locationtech/jts/operation/buffer/BufferOp.js';
import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory.js';
import Coordinate from 'jsts/org/locationtech/jts/geom/Coordinate.js';

export default class SelectionHandler {
    constructor(map, layerSettingsHandler, generalSettingsHandler, mapId, classId, featureHandler, resourcesHandler) {
        this.mapId = mapId;
        this.classId = classId;
        $('#xpmap-' + this.mapId + '-' + this.classId).parent().append('<div id="' + this.mapId + '-' + this.classId + '-info" class="featureInfo" style="position: absolute; height: 1px; width: 1px; z-index: 5 !important;"></div>');
        this.map = map;
        this.layerSettingsHandler = layerSettingsHandler;
        this.generalSettingsHandler = generalSettingsHandler;
        this.resourcesHandler = resourcesHandler;
        this.hasClickTooltip = false;
        this.selectionHolder = null;
        this.hoverHolder = null;
        this.isActive = true;
        this.ignoreNextPostCompose = false;
        this.pixelOld = null;
        this.tooltip = null;
        this.tooltipSelector = "#" + this.mapId + '-' + this.classId + "-info";
        this.tooltipClassSelector = '.tooltip';
        this.tooltipTimeout = null;
        this.isTooltipHidden = false;
        this.styleHandler = null;
        this.layerHandler = null;
        this.featureHandler = featureHandler;
        this.copyMode = false;
        this.olParser = new OL3Parser();
        this.olParser.inject(
            Point,
            LineString,
            LinearRing,
            Polygon,
            MultiPoint,
            MultiLineString,
            MultiPolygon,
            GeometryCollection
        );
        this._handleHover = this.throttle(this._handleHover.bind(this), 50);
        this.lastPointerPixel = null;
        window.selectionHandler = this;
    }

    init() {
        this.selectionHolder = this._computeSelectionHolder();
        this.hoverHolder = this._computeHoverHolder();
        this._addHandlers();
    }

    disableSelection() {
        this.isActive = false;
    }

    enableSelection() {
        this.isActive = true;
    }

    clearLayerSelection(layerId) {
        let layer = this.selectionHolder.layers[layerId];
        let fids = Object.keys(layer.features);
        fids.forEach(fid => {
            layer.features[fid].set('xstate', styleTypes.DEFAULT_STYLE_TYPE);
        });

        layer.features = {};
    }

    computeSelection(layer, settings) {
        let layerId = layer.get("uid");
        if (layerId) {
            if (settings == null) {
                settings = this.layerSettingsHandler.getLayerSettings(layerId);
            }

            this.selectionHolder.layers[layerId] = {};
            this.selectionHolder.layers[layerId].layer = layer;
            this.selectionHolder.layers[layerId].features = {};
            this.selectionHolder.layers[layerId].tooltip = settings.Tooltip == null || settings.Tooltip.trim() == '' ? settings.TooltipComplex : settings.Tooltip;
            this.selectionHolder.layers[layerId].active = settings.Selectable;

            if (settings.Geoservice != null) {
                this.selectionHolder.layers[layerId].idField = settings.Geoservice.IdColumn;
            } else if (settings.Temporary != null) {
                this.selectionHolder.layers[layerId].idField = settings.Temporary.IdColumn;
            } else {
                this.selectionHolder.layers[layerId].idField = settings.Entity.PkFieldName;
            }
        }
    }

    computeHover(layer, settings) {
        let layerId = layer.get("uid");
        if (layerId) {
            if (settings == null) {
                settings = this.layerSettingsHandler.getLayerSettings(layerId);
            }

            this.hoverHolder.layers[layerId] = {};
            this.hoverHolder.layers[layerId].layer = layer;
            this.hoverHolder.layers[layerId].features = {};
            this.hoverHolder.layers[layerId].tooltip = settings.Tooltip == null || settings.Tooltip.trim() == '' ? settings.TooltipComplex : settings.Tooltip;
            this.hoverHolder.layers[layerId].active = settings.Selectable;


            if (settings.Geoservice != null) {
                this.hoverHolder.layers[layerId].idField = settings.Geoservice.IdColumn;
            } else if (settings.Temporary != null) {
                this.hoverHolder.layers[layerId].idField = settings.Temporary.IdColumn;
            } else {
                this.hoverHolder.layers[layerId].idField = settings.Entity.PkFieldName;
            }
        }
    }

    notifySelection(feature, layerId, layer) {
        $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: [feature], layerId: layerId, layer: layer }, this, this.classId);
    }

    selectByFeature(feature) {
        let geometry = feature.getGeometry();

        let looseBboxFeatures = this._getFeaturesByLooseBbox(this.map, geometry, (layer) => {
            return this._eligibleForInteraction(layer, this.selectionHolder);
        });

        let jstsSearchGeom = null;

        if (geometry instanceof Circle) {
            let [cx, cy] = geometry.getCenter();
            let radius = geometry.getRadius();
            let geomFactory = new GeometryFactory();
            let jstsCenter = geomFactory.createPoint(new Coordinate(cx, cy));
            jstsSearchGeom = BufferOp.bufferOp(jstsCenter, radius);
        } else {
            jstsSearchGeom = this.olParser.read(geometry);
        }

        let features = looseBboxFeatures.filter(targetFeature => {
            try {
                let targetGeometry = targetFeature.getGeometry();
                let jstsTargetGeometry = this.olParser.read(targetGeometry);

                let relate = new RelateOp(jstsSearchGeom, jstsTargetGeometry);
                let im = relate.getIntersectionMatrix();
                if (im.isIntersects()) {
                    return true;
                }

                return false;
            } catch (err) {
                return false;
            }
        });

        if (features.length > 0) {
            if (features.length == 1) {
                let feature = features[0];
                let selectionLayer = this.selectionHolder.layers[feature.layerId];
                var fid = feature.getProperties()[selectionLayer.idField];

                if (fid in selectionLayer.features) {
                    delete selectionLayer.features[fid];
                    feature.set('xstate', styleTypes.DEFAULT_STYLE_TYPE);

                    if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                        $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                    } else {
                        $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: null, layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                    }

                    this.tooltip = null;
                    this._hideTooltip();
                } else {
                    if (this.selectionHolder.allowMultiple) {
                        this._clearAllSelectedExcept(selectionLayer);

                        if (selectionLayer.features == null) {
                            selectionLayer.features = {};
                        }

                        selectionLayer.features[fid] = feature;
                        feature.set('xstate', styleTypes.SELECT_STYLE_TYPE);

                        if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: [feature], layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                        } else {
                            $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: [fid], layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                        }

                        this.tooltip = null;
                        this._hideTooltip();
                    } else {
                        if (this.copyMode) {
                            this.copyMode = false;
                            $event.notify(eventTypes.FEATURE_TOOLS_COPY_ENDED, { event: null, feature: feature }, this, this.classId);
                            this._clearAllSelected();
                        } else {
                            this._clearAllSelected();
                            selectionLayer.features = {};
                            selectionLayer.features[fid] = feature;
                            feature.set('xstate', styleTypes.SELECT_STYLE_TYPE);

                            if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                                $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: [feature], layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                            } else {
                                $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: [fid], layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                            }

                            this.tooltip = null;
                            this._hideTooltip();
                        }
                    }
                }
            } else {
                $event.notify(eventTypes.MAP_MULTIPLE_LAYER_SELECTION, { event: null, features: features }, this, this.classId);
            }
        }
    }

    getVisibleLayersInExtent(extent) {
        let visibleFeatures = this.getVisibleFeaturesInExtent(extent);
        let visibleLayers = this.filterHierarchy(this.layerSettingsHandler.layers, visibleFeatures);

        return visibleLayers;
    }

    filterHierarchy(hierarchy, features) {
        const allowedIds = new Set(features.map(obj => obj.layerId));

        let recurse = (items) => {
            return items.reduce((filtered, item) => {
                if (item.Type === 'ENTITY') {
                    const interp = item.Interpretation;
                    if (interp === 'NATIVE_XP' || interp === 'WFS' || interp === 'VECTOR_TILE') {
                        if (allowedIds.has(item.Id)) {
                            this.addClassificationFeatures(item, features);
                            filtered.push({ ...item });
                        }
                    } else {
                        filtered.push({ ...item });
                    }

                } else if (item.Type === 'GROUP') {
                    const children = Array.isArray(item.Items) ? item.Items : [];
                    const newChildren = recurse(children);
                    if (newChildren.length > 0) {
                        filtered.push({
                            ...item,
                            Items: newChildren
                        });
                    }
                } else if (item.VisibleByDefault){
                    filtered.push({ ...item });
                }

                return filtered;
            }, []);
        }
        return recurse(hierarchy);
    }

    addClassificationFeatures(item, features) {
        if (item.classifications == null) {
            let classifs = this._getClassifications(this.styleHandler.styles[item.IdDefaultStyle]);

            if (classifs == null) {
                classifs = [];
            }

            item.classifications = classifs;
            item.hasClassification = classifs.length > 0;
        }

        if (item.classifications != null && item.classifications.length > 0) {
            let currentFeatures = features.filter(x => x.layerId == item.Id);

            item.usedClassifications = {};
            let mapLayer = this.layerHandler.getLayerById(item.Id)[0];
            currentFeatures.forEach(currentFeature => {
                if (mapLayer.getStyle && typeof mapLayer.getStyle == 'function') {
                    let symbols = mapLayer.getStyle()(currentFeature);

                    if (symbols != null && symbols.length > 0) {
                        let symbol = symbols[0];

                        let zIndex = symbol.getZIndex();

                        if (zIndex < 0) {
                            zIndex = -zIndex;
                        }

                        item.usedClassifications[zIndex] = {};
                    }
                }
            });
        }
    }

    _getClassifications(style) {
        if (style == null) return null;

        if (style.style != null) {
            style = style.style;
        }

        if (style.Type != null && style.Type == 'TEMATIC') {
            let result = [];
            let idx = 1;

            if (style.Intervals != null && style.Intervals.length > 0) {
                style.Intervals.forEach(interval => {
                    result.push({ idx: idx, name: this._getNameForInterval(interval) });
                    idx++;
                });
            }

            return result;
        } else if (style.Intervals != null && style.Intervals.length > 1) {
            let result = [];
            let idx = 1;

            if (style.Intervals != null && style.Intervals.length > 0) {
                style.Intervals.forEach(interval => {
                    result.push({ idx: idx, name: this._getNameForInterval(interval) });
                    idx++;
                });
            }

            return result;
        } else if (style.length > 1) {
            let result = [];
            let idx = 0;
            style.forEach(styleItem => {
                result.push({ idx: idx, name: styleItem.Name });
                idx++;
            });

            return result;
        }
    }

    _getNameForInterval(interval) {
        let name = this.resourcesHandler.get('LegendIntervalTemplate');

        if (name == 'LegendIntervalTemplate') {
            name = 'From {0} to {1}';
        }

        return name.replaceAll('{0}', interval.min).replaceAll('{1}', interval.max);
    }

    getVisibleFeaturesInExtent(extent) {
        let result = [];
        let viewResolution = this.map.getView().getResolution();

        this.map.getLayers().forEach(layer => {
            if (layer.get('visible')) {
                let minResolution = layer.get('minResolution');
                let maxResolution = layer.get('maxResolution');

                if (minResolution <= viewResolution && maxResolution >= viewResolution) {
                    let source = layer.getSource && layer.getSource();
                    if (source && typeof source.getFeaturesInExtent == 'function') {
                        let features = source.getFeaturesInExtent(extent);

                        for (let feature of features) {
                            if (layer.getStyle && layer.getStyle() && layer.getStyle()(feature).length > 0) {
                                result.push(feature);
                            }
                        }
                    }
                }
            }
        });

        return result;
    }

    _getFeaturesByLooseBbox(map, geometry, layerFilter = () => true) {
        const extent = geometry.getExtent();

        const foundFeatures = [];

        map.getLayers().forEach(layer => {
            if (!layerFilter(layer)) return;

            const source = layer.getSource && layer.getSource();
            if (!source || typeof source.getFeaturesInExtent !== 'function') return;

            const features = source.getFeaturesInExtent(extent);
            for (const feature of features) {
                const geometry = feature.getGeometry();
                if (layer.getStyle && layer.getStyle() && layer.getStyle()(feature).length > 0 && geometry && geometry.intersectsExtent(extent)) {
                    foundFeatures.push(feature);
                }
            }
        });

        return foundFeatures;
    }

    deselectFeature(layerId, featureId) {
        if (this.selectionHolder.layers[layerId] == null) {
            throw "Target layer cannot be selected";
        }

        let feature = this._getLayerById(layerId).getSource().getFeatures().find((item) => item.get(this.layerSettingsHandler.getLayerSettings(layerId).Entity.PkFieldName) == featureId);
        let selectionLayer = this.selectionHolder.layers[layerId];
        var fid = featureId;

        if (fid in selectionLayer.features) {
            delete selectionLayer.features[fid];
            this.tooltip = null;
            this._hideTooltip();

            if (feature != null && Object.keys(feature).length > 0) {
                feature.set('xstate', styleTypes.DEFAULT_STYLE_TYPE);
            }

            if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
            } else {
                $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: null, layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
            }
        }
    }

    select(layerId, featureId, initialized, ignoreNotification, force) {
        if (this.selectionHolder.layers[layerId] == null) {
            throw "Target layer cannot be selected";
        }

        let feature;

        if (this.layerSettingsHandler.getLayerSettings(layerId).Entity) {
            feature = this._getLayerById(layerId).getSource().getFeatures().find((item) => item.get(this.layerSettingsHandler.getLayerSettings(layerId).Entity.PkFieldName) == featureId);
        } else if (this.layerSettingsHandler.getLayerSettings(layerId).Geoservice) {
            feature = this._getLayerById(layerId).getSource().getFeatures().find((item) => item.get(this.layerSettingsHandler.getLayerSettings(layerId).Geoservice.IdColumn) == featureId);
        }

        let selectionLayer = this.selectionHolder.layers[layerId];
        var fid = featureId;

        if (fid in selectionLayer.features && !force) {
            delete selectionLayer.features[fid];

            if (feature != null && Object.keys(feature).length > 0) {
                feature.set('xstate', styleTypes.DEFAULT_STYLE_TYPE);
            }

            if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
            } else {
                $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: null, layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
            }
        } else {
            if (this.selectionHolder.allowMultiple) {
                if (this.copyMode) {
                    this.copyMode = false;
                    $event.notify(eventTypes.FEATURE_TOOLS_COPY_ENDED, { event: null, feature: feature }, this, this.classId);
                    this._clearAllSelected();
                } else {
                    this._clearAllSelectedExcept(selectionLayer);

                    if (selectionLayer.features == null) {
                        selectionLayer.features = {};
                    }

                    if (feature == null) {
                        feature = {};
                    }

                    selectionLayer.features[fid] = feature;

                    if (feature != null && Object.keys(feature).length > 0) {
                        feature.set('xstate', styleTypes.SELECT_STYLE_TYPE);

                        if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: [feature], layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                        } else {
                            $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: [fid], layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                        }

                        this.tooltip = null;
                        this._hideTooltip();
                    }
                }
            } else {
                this._clearAllSelected();
                selectionLayer.features = {};

                if (feature == null) {
                    feature = {};
                }

                selectionLayer.features[fid] = feature;

                if (feature != null && Object.keys(feature).length > 0) {
                    if (this.copyMode) {
                        this.copyMode = false;
                        $event.notify(eventTypes.FEATURE_TOOLS_COPY_ENDED, { event: null, feature: feature }, this, this.classId);
                        this._clearAllSelected();
                    } else {
                        feature.set('xstate', styleTypes.SELECT_STYLE_TYPE);

                        if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: [feature], layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                        } else {
                            $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: [fid], layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                        }

                        this.tooltip = null;
                        this._hideTooltip();
                    }
                }
            }
        }
    }

    _getClusterFeatureId(featureId) {
        var featureKey = '' + featureId;
        return this._hashCode(featureKey);
    }

    _hashCode(string) {
        var hash = 0, i, chr;
        if (string.length === 0) return hash;
        for (i = 0; i < string.length; i++) {
            chr = string.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return hash;
    }

    _computeSelectionHolder() {
        let result = {};
        this.hasClickTooltip = (this.generalSettingsHandler.settings.TooltipDisplayType != null && this.generalSettingsHandler.settings.TooltipDisplayType.toLowerCase() == mapEventTypes.CLICK) || !isDesktopDevice();
        result.allowMultiple = this.generalSettingsHandler.settings.AllowMultipleSelection;
        result.layers = {};

        return result;
    }

    _computeHoverHolder() {
        let result = {};
        this.hasHoverTooltip = (this.generalSettingsHandler.settings.TooltipDisplayType != null && this.generalSettingsHandler.settings.TooltipDisplayType.toLowerCase() == mapEventTypes.HOVER) || !isDesktopDevice();
        result.layers = {};

        return result;
    }

    _addHandlers() {
        this.ignoreNextPostCompose = false;

        this.map.on(['contextmenu', 'singleclick', 'dblclick', 'postcompose', 'moveend'], async (evt) => {
            if (evt.type == 'singleclick') {
                this._handleSelection(evt, true);
                $event.notify(eventTypes.MAP_POINTER_CLICK, evt, this, this.classId);
            } else if (evt.type == 'contextmenu') {
                evt.preventDefault();
                $event.notify(eventTypes.RIGHT_CLICK, evt, this, this.classId);
            } else if (evt.type == 'dblclick') {
                evt.preventDefault();
                this._handleSelection(evt, true);
            }
            else if (evt.type == 'postcompose') {
                if (this.ignoreNextPostCompose) {
                    this.ignoreNextPostCompose = false;
                }
                else {
                    evt.pixel = this.pixelOld;
                    if (this.hasClickTooltip && this.tooltip != null && this.tooltip.feature != null) {
                        this._refreshTooltip();
                    }
                }
            } else if (evt.type == 'moveend') {
                $event.notify(eventTypes.MAP_MOVE_END, null, this, this.classId);
            }
        });

        this.map.on('pointermove', this._handleHover);

        $event.register(eventTypes.LAYER_SELECTABILITY_CHANGED, this._getLayerSelectabilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, this._getFeatureToolsVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_TOOLS_EDIT_STARTED, this._getFeatureEditStartedHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_TOOLS_COPY_STARTED, this._getFeatureCopyStartedHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_TOOLS_EDIT_ENDED, this._getFeatureEditEndedHandler(), this, this.classId);
    }

    _getFeatureEditEndedHandler() {
        var handler = (eventName, event, sender) => {
        };

        return handler;
    }

    _getFeatureEditStartedHandler() {
        let handler = (eventName, event, sender) => {
        };

        return handler;
    }

    _getFeatureCopyStartedHandler() {
        let handler = (eventName, event, sender) => {
            this.isTooltipHidden = false;
            this.isActive = true;
            this.copyMode = true;
        };

        return handler;
    }

    _getFeatureToolsVisibilityChangedHandler() {
        let handler = (eventName, event, sender) => {
            if (event.visible) {
                this.isTooltipHidden = true;
                this.isActive = false;
                this._clearAllSelected();
                this._refreshTooltip();

            } else {
                this.isTooltipHidden = false;
                this.isActive = true;
                this._refreshTooltip();

            }
        };

        return handler;
    }

    _refreshTooltip() {
        if (this.tooltip != null) {
            var pixel = this.map.getPixelFromCoordinate(this.tooltip.coordinates);

            if (this.tooltip != null && this.tooltip.pixel != null) {
                if (pixel[0] == this.tooltip.pixel[0] && pixel[1] == this.tooltip.pixel[1] && $('.tooltip').length > 0) {
                    return;
                }
            }

            var layerMinResolution = this.tooltip.layer.getMinResolution();
            var layerMaxResolution = this.tooltip.layer.getMaxResolution();
            var currentResolution = this.map.getView().getResolution();
            let tooltipHeight = null;
            let tooltipWidth = null;

            if ($('.tooltip') != null && $('.tooltip').length > 0) {
                tooltipHeight = $('.tooltip')[0].offsetHeight;
                tooltipWidth = $('.tooltip')[0].offsetWidth;
            } else {
                if (this.tooltip.tooltip != null && this.tooltip.tooltip != '') {
                    var t = '<div>' + this.tooltip.tooltip + '</div>';
                    tooltipHeight = $(t).height();
                    tooltipWidth = $(t).width();
                }
            }

            this._hideTooltip();
            if (currentResolution <= layerMaxResolution && currentResolution >= layerMinResolution && !this.isTooltipHidden) {
                this.tooltip.pixel = pixel;
                this._handleShowTooltip(this.tooltip.feature, this.tooltip.tooltip, pixel, this.tooltip.layer.get('interpretation'), tooltipHeight, tooltipWidth);
            }
        }
    }

    _createTooltipControl(position) {
        var featureTooltip = $(this.tooltipSelector);
        featureTooltip.tooltip({
            animation: false,
            trigger: 'manual',
            html: true,
            placement: position,
            customArrow: true
        });
    }

    _handleShowTooltip(feature, tooltip, pixel, interpretation, height, width) {
        var tooltipContent = this._getTooltipContent(tooltip, feature, interpretation);

        if (width == null || width == 0) {
            width = 230;
        }

        if (tooltipContent != null) {
            this._createTooltipControl('top');
            $(this.tooltipSelector).attr('data-original-title', 'empty').tooltip('_fixTitle').tooltip('show');

            var x = pixel[0] - ($(this.tooltipClassSelector)[0].offsetWidth / 2);

            var y = 0;
            y = pixel[1];

            var tooltipPosition = 'top';

            if (pixel[0] < 0 && this.hasClickTooltip) {
                this._hideTooltip();
                return;
            }

            if (pixel[1] < 0 && this.hasClickTooltip) {
                this._hideTooltip();
                return;
            }

            if (pixel[0] > $(this.targetSelector).width() && this.hasClickTooltip) {
                this._hideTooltip();
                return;
            }

            if (pixel[1] > $(this.targetSelector).height() && this.hasClickTooltip) {
                this._hideTooltip();
                return;
            }

            if (x < 10) {
                x = pixel[0];
                pixel[0] += 20;
                tooltipPosition = 'left';
            } else if (x > $(this.targetSelector).width() - $(this.tooltipClassSelector)[0].offsetWidth) {
                pixel[0] -= 20;
                tooltipPosition = 'right';
            }

            let newY = 0;

            if ((tooltipPosition == 'left' || tooltipPosition == 'right') && height != null) {
                let mapHeight = $(this.targetSelector).height();
                if (y > mapHeight / 2) {
                    if (mapHeight < y + (height / 2)) {
                        pixel[1] = y - ((y + (height / 2)) - mapHeight) - 3;
                        let bottomDistance = mapHeight - y;
                        newY = height - bottomDistance;
                    } else {
                        newY = height / 2;
                    }
                } else {
                    if (y - (height / 2) < 0) {
                        pixel[1] = 258;
                        newY = y;
                    } else {
                        newY = height / 2;
                    }
                }
            }

            if (tooltipPosition == 'top' && height != null) {
                let mapHeight = $(this.targetSelector).height();

                if (y > mapHeight / 2) {
                    if (y > height) {
                        if (height < mapHeight / 2) {
                            tooltipPosition = 'top';
                            pixel[1] -= 20;
                        } else {
                            tooltipPosition = 'bottom';
                            pixel[1] -= 20;
                        }
                    } else {
                        if (mapHeight < y + (height / 2)) {
                            pixel[1] = y - ((y + (height / 2)) - mapHeight) - 3;
                            let bottomDistance = mapHeight - y;
                            newY = height - bottomDistance;
                        } else {
                            newY = height / 2;
                        }

                        if (x < width) {
                            tooltipPosition = 'right';
                            pixel[0] += 20;
                        } else {
                            tooltipPosition = 'left';
                            pixel[0] -= 20;
                        }
                    }
                } else {
                    if (mapHeight - y > height) {
                        if (height < mapHeight / 2) {
                            tooltipPosition = 'bottom';
                            pixel[1] += 20;
                        } else {
                            tooltipPosition = 'top';
                            pixel[1] += 20;
                        }
                    } else {
                        if (y - (height / 2) < 0) {
                            pixel[1] = 258;
                            newY = y;
                        } else {
                            newY = height / 2;
                        }

                        if (x < width) {
                            tooltipPosition = 'right';
                            pixel[0] += 20;
                        } else {
                            tooltipPosition = 'left';
                            pixel[0] -= 20;
                        }
                    }
                }
            }

            this._hideTooltip();
            this._createTooltipControl(tooltipPosition);
            $(this.tooltipSelector).attr('data-original-title', 'empty').tooltip('_fixTitle').tooltip('show');
            $(this.tooltipSelector).css({ left: pixel[0], top: pixel[1], transform: 'none' });
            $('.tooltip').css({ left: pixel[0], top: pixel[1], transform: 'none' });
            if ((tooltipPosition == 'left' || tooltipPosition == 'right')) {
                $('.arrow').css({ top: newY });
            }
            $('.tooltip-inner')[0].style.width = 'auto';
            $('.tooltip-inner')[0].style['min-width'] = '230px';
            $('.tooltip-inner')[0].innerText = "";
            $('.tooltip-inner')[0].innerHTML = tooltipContent;
        }
    }

    _getTooltipContent(template, feature, interpretation) {
        if (template == null || template.trim() == '') {
            return;
        }

        var tooltip = template;

        var properties = [];

        if (interpretation.toLowerCase() == 'cluster') {
            if (feature.get('features') != null && feature.get('features').length == 1) {
                properties = feature.get('features')[0].getProperties();
            } else {
                return null;
            }
        } else {
            properties = feature.getProperties();
        }

        for (var k in properties) {
            while (tooltip.indexOf("{" + k + "}") > -1) {
                tooltip = tooltip.replace("{" + k + "}", (properties[k] == null || properties[k] == '') ? "-" : properties[k]);
            }
        }

        if (tooltip == null || tooltip.trim() == "") {
            return;
        }
        tooltip = "<div class='tooltip-body'><div class='tooltip-body-content'> <div class='tooltip-details'>" + tooltip + "</div></div></div>";

        return tooltip;
    }

    _hideTooltip() {
        $(this.tooltipSelector).tooltip('dispose');
        if (this.tooltipTimeout != null) {
            clearTimeout(this.tooltipTimeout);
        }
    }

    _handlePostCompose(evt) {
        let changed = {};

        this.layers.forEach(layer => {
            let id = layer.get('uid');
            if (this.layerSettingsHandler.getLayerSettings(id).Charts != null) {
                let features = layer.getSource().getFeatures();
                changed[id] = features;
            }
        });

        $event.notify(eventTypes.FEATURES_CHANGED, changed, this, this.classId);
    }

    _getLayerSelectabilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null && data.layerId != null) {
                if (this.hoverHolder.layers[data.layerId]) {
                    this.hoverHolder.layers[data.layerId].active = data.selectable;

                    if (!data.selectable) {
                        this._clearLayerHover(this.hoverHolder.layers[data.layerId]);
                    }
                }

                if (this.selectionHolder.layers[data.layerId]) {
                    this.selectionHolder.layers[data.layerId].active = data.selectable;

                    if (!data.selectable) {
                        this._clearLayerSelection(this.selectionHolder.layers[data.layerId]);
                    }
                }
            }
        };

        return handler;
    }

    _handleSelection(evt, isSingleClick) {
        if (!this.isActive) {
            return;
        }

        if (evt.originalEvent == null) {
            return;
        }

        let pixel = this.map.getEventPixel(evt.originalEvent);

        if (pixel == null) {
            return;
        }

        let features = this._getFeaturesAtPixel(pixel, 5, (layer) => {
            return this._eligibleForInteraction(layer, this.selectionHolder);
        });

        if (features.length > 0) {
            //SM: din cauza acestei optiuni, nu mai merge selectia unuia din obiecte, atunci cand nu este selectie multipla
            //if (features.length == 1 || !this.generalSettingsHandler.settings.AllowMultipleSelection) {
            if (features.length == 1) {
                let feature = features[0];
                let selectionLayer = this.selectionHolder.layers[feature.layerId];
                var fid = feature.getProperties()[selectionLayer.idField];

                if (fid in selectionLayer.features) {
                    if (isSingleClick) {
                        delete selectionLayer.features[fid];
                        feature.set('xstate', styleTypes.DEFAULT_STYLE_TYPE);

                        if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                        } else {
                            $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: null, layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                        }

                        this.tooltip = null;
                        this._hideTooltip();
                    }
                } else {
                    if (this.copyMode) {
                        this.copyMode = false;
                        $event.notify(eventTypes.FEATURE_TOOLS_COPY_ENDED, { event: evt, feature: feature }, this, this.classId);
                        this._clearAllSelected();
                        return;
                    }

                    if (this.selectionHolder.allowMultiple) {
                        this._clearAllSelectedExcept(selectionLayer);

                        if (selectionLayer.features == null) {
                            selectionLayer.features = {};
                        }

                        selectionLayer.features[fid] = feature;
                        feature.set('xstate', styleTypes.SELECT_STYLE_TYPE);
                        $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);

                        if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: [feature], layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                        } else {
                            $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: [fid], layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                        }

                        this.tooltip = null;
                        this._hideTooltip();
                    } else {
                        this._clearAllSelected();
                        selectionLayer.features = {};
                        selectionLayer.features[fid] = feature;
                        feature.set('xstate', styleTypes.SELECT_STYLE_TYPE);
                        $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);

                        if (selectionLayer.layer.get('temporarySettings') != null && selectionLayer.layer.get('temporarySettings').editable) {
                            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: [feature], layerSettings: selectionLayer.layer.get('temporarySettings') }, this, this.classId);
                        } else {
                            $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: [fid], layerId: selectionLayer.layer.get('uid'), layer: selectionLayer.layer }, this, this.classId);
                        }

                        this.tooltip = null;
                        this._hideTooltip();
                    }

                    if (this.hasClickTooltip) {

                        this._storeTooltip(selectionLayer.layer, selectionLayer.idField, feature, selectionLayer.tooltip, pixel);

                        this._showTooltip(feature, selectionLayer.tooltip, pixel, selectionLayer.layer.get('interpretation'));
                        this._refreshTooltip();
                    }
                }
            } else {
                $event.notify(eventTypes.MAP_MULTIPLE_LAYER_SELECTION, { event: evt, features: features }, this, this.classId);
            }
        }
    }

    _showTooltip(feature, tooltip, pixel, interpretation) {
        let selectedFeatures = this.getAllMapSelectedFeatures();

        if (selectedFeatures.length > 0) {
            return;
        }

        if (this.tooltipTimeout != null) {
            clearTimeout(this.tooltipTimeout);
        }

        let tooltipHeight = null;
        let tooltipWidth = null;

        if (tooltip != null && tooltip != '') {
            var t = '<div>' + tooltip + "</div>";
            tooltipHeight = $(t).height();
            tooltipWidth = $(t).width();
        }

        if (this.hasHoverTooltip) {
            this.tooltipTimeout = setTimeout(() => {
                this._handleShowTooltip(feature, tooltip, pixel, interpretation, tooltipHeight, tooltipWidth);
            }, 200);
        } else {
            this._handleShowTooltip(feature, tooltip, pixel, interpretation, tooltipHeight, tooltipWidth);
        }
    }

    _storeTooltip(layer, idField, feature, tooltip, pixel) {
        if (this.tooltip == null) {
            this.tooltip = {};
        }
        this.tooltip.layer = layer;
        this.tooltip.idField = idField;
        this.tooltip.feature = feature;
        this.tooltip.tooltip = tooltip;
        this.tooltip.pixel = pixel;

        this.tooltip.coordinates = this.map.getCoordinateFromPixel(pixel);
    }

    async _getFeaturesAtPixelSpatial(map, pixel, layerFilter = () => true, hitTolerance = 5) {
        const coordinate = map.getCoordinateFromPixel(pixel);
        const resolution = map.getView().getResolution();

        const toleranceInMapUnits = hitTolerance * resolution;
        const extent = [
            coordinate[0] - toleranceInMapUnits,
            coordinate[1] - toleranceInMapUnits,
            coordinate[0] + toleranceInMapUnits,
            coordinate[1] + toleranceInMapUnits
        ];

        const foundFeatures = [];

        map.getLayers().forEach(async layer => {
            if (!layerFilter(layer)) return;

            let layerConfig = this.layerSettingsHandler.getLayerSettings(layer.get('uid'));

            let defaultStyle = layerConfig.IdDefaultStyle == null ? 'sys_' + styleTypes.SYSTEM_STYLE_ALL : layerConfig.IdDefaultStyle;

            let styleDefinition = this.styleHandler.getStyleById(defaultStyle);

            if (styleDefinition.hasPoints) {
                try {
                    let features = await layer.getFeatures(pixel);

                    features.forEach(feature => {
                        if (layer.getStyle && layer.getStyle() && layer.getStyle()(feature).length > 0) {
                            foundFeatures.push(feature);
                        }
                    });

                    if (features == null || features.length == 0) {
                        let source = layer.getSource && layer.getSource();
                        if (!source || typeof source.getFeaturesInExtent !== 'function') return;

                        features = source.getFeaturesInExtent(extent);
                        for (let feature of features) {
                            let geometry = feature.getGeometry();
                            if (layer.getStyle && layer.getStyle() && layer.getStyle()(feature).length > 0 && geometry && geometry.intersectsExtent(extent)) {
                                foundFeatures.push(feature);
                            }
                        }
                    }
                } catch (err) {
                    const source = layer.getSource && layer.getSource();
                    if (!source || typeof source.getFeaturesInExtent !== 'function') return;

                    const features = source.getFeaturesInExtent(extent);
                    for (const feature of features) {
                        const geometry = feature.getGeometry();
                        if (layer.getStyle && layer.getStyle() && layer.getStyle()(feature).length > 0 && geometry && geometry.intersectsExtent(extent)) {
                            foundFeatures.push(feature);
                        }
                    }
                }
            } else {
                const source = layer.getSource && layer.getSource();
                if (!source || typeof source.getFeaturesInExtent !== 'function') return;

                const features = source.getFeaturesInExtent(extent);
                for (const feature of features) {
                    const geometry = feature.getGeometry();
                    if (layer.getStyle && layer.getStyle() && layer.getStyle()(feature).length > 0 && geometry && geometry.intersectsExtent(extent)) {
                        foundFeatures.push(feature);
                    }
                }
            }
        });

        return foundFeatures;
    }

    getAllMapSelectedFeatures() {
        let layerKeys = Object.keys(this.selectionHolder.layers);

        let result = [];

        layerKeys.forEach(layerKey => {
            let selectionLayer = this.selectionHolder.layers[layerKey];

            var keys = Object.keys(selectionLayer.features);

            for (var i = 0; i < keys.length; i++) {
                result.push(selectionLayer.features[keys[i]]);
            }
        });

        return result;
    }

    getAllSelectedFeatures(layerId) {
        var selectionLayer = this.selectionHolder.layers[layerId];

        if (selectionLayer != null) {
            var result = [];
            var keys = Object.keys(selectionLayer.features);

            for (var i = 0; i < keys.length; i++) {
                result.push(selectionLayer.features[keys[i]]);
            }

            return result;
        }

        return [];
    }

    throttle(fn, wait) {
        let inThrottle = false;
        return (...args) => {
            if (!inThrottle) {
                fn(...args);
                inThrottle = true;
                setTimeout(() => (inThrottle = false), wait);
            }
        };
    }

    _getFeaturesAtPixel(pixel, tolerance, filter, isHover) {
        let view = this.map.getView();
        let resolution = view.getResolution();
        let coordinate = this.map.getCoordinateFromPixel(pixel);
        let hits = [];
        this.map.getLayers().forEach(layer => {
            if (!filter(layer)) return;

            let layerConfig = this.layerSettingsHandler.getLayerSettings(layer.get("uid"));

            let actualTolerance = tolerance;

            if (layerConfig && layerConfig.Entity && layerConfig.Entity.GeometryFieldType == 'POINT') {
                actualTolerance = 30;
            }

            let toleranceInMapUnits = actualTolerance * resolution;
            let extent = [
                coordinate[0] - toleranceInMapUnits,
                coordinate[1] - toleranceInMapUnits,
                coordinate[0] + toleranceInMapUnits,
                coordinate[1] + toleranceInMapUnits
            ];

            let src = layer.getSource?.();
            if (!src || typeof src.getFeaturesInExtent !== 'function') return;

            let candidates = src.getFeaturesInExtent(extent);

            for (let feat of candidates) {
                if (feat.getGeometry().intersectsExtent(extent)) {
                    if (feat.getGeometry().getType() === 'Point') {
                        let closest = feat.getGeometry().getClosestPoint(coordinate);
                        let px = this.map.getPixelFromCoordinate(closest);
                        let dx = px[0] - pixel[0];
                        let dy = px[1] - pixel[1];
                        var hitTol = actualTolerance;
                        let hitLayer = this.layerHandler.getLayerById(feat.layerId);

                        if (hitLayer != null && hitLayer.length > 0) {
                            hitLayer = hitLayer[0];

                            let styleFn = hitLayer.getStyle();

                            if (styleFn) {
                                let style = styleFn(feat);
                                style = style.find(x => x.getImage);
                                if (style && style.getImage) {
                                    let image = style.getImage();

                                    if (image) {
                                        let size = image.getSize();
                                        let scale = image.getScale() || 1;

                                        if (size) {
                                            var iconRadius = Math.max(size[0], size[1]) * scale / 2;
                                            hitTol = Math.min(hitTol, iconRadius);
                                        }
                                    }
                                }
                            }
                        }

                        if (Math.hypot(dx, dy) <= hitTol) {
                            hits.push(feat);

                            if (isHover) {
                                break;
                            }
                        }
                    } else {
                        let style = layer.getStyle();
                        if (style && style(feat).length > 0) {
                            hits.push(feat);
                        }
                    }
                }
            }
        });

        return hits;
    }

    _eligibleForInteraction(layer, interactionHolder) {
        if (interactionHolder.layers[layer.get("uid")] != null) {
            if (interactionHolder.layers[layer.get("uid")].layer != null) {
                if (interactionHolder.layers[layer.get("uid")].active) {
                    if (interactionHolder.layers[layer.get("uid")].layer.get('visible')) {
                        let minResolution = interactionHolder.layers[layer.get("uid")].layer.get('minResolution');
                        let maxResolution = interactionHolder.layers[layer.get("uid")].layer.get('maxResolution');
                        let viewResolution = this.map.getView().getResolution();

                        if (minResolution <= viewResolution && maxResolution >= viewResolution) {
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }

    _handleHover(evt) {
        $event.notify(eventTypes.MAP_POINTER_MOVE, evt, this, this.classId);
        this.lastPointerPixel = evt.pixel;
        if (!this.isActive) {
            try {
                let hit = this.map.hasFeatureAtPixel(evt.pixel, {
                    layerFilter: layer => layer.get("uid") === layerTypes.EDITING
                });

                if (hit) {
                    this.map.getViewport().style.cursor = 'pointer';
                } else if (this.map.getViewport().style.cursor == 'pointer') {
                    this.map.getViewport().style.cursor = '';
                }

                return;
            } catch (err) {
                if (this.map.getViewport().style.cursor == 'pointer') {
                    this.map.getViewport().style.cursor = '';
                }
                return;
            }
        }

        if (evt.originalEvent == null) {
            return;
        }

        let pixel = this.map.getEventPixel(evt.originalEvent);

        if (pixel == null) {
            return;
        }

        let features = this._getFeaturesAtPixel(pixel, 5, (layer) => {
            return this._eligibleForInteraction(layer, this.hoverHolder);
        }, true);

        if (features.length == 0) {
            this.map.getViewport().style.cursor = 'inherit';

            if (this.hasHoverTooltip) {
                this._hideTooltip();
            }

            this._clearAllHovered();
        } else {
            let layers = this._getOrderedHoverLayers();
            let hit = false;

            for (let i = 0; i < layers.length; i++) {
                let layerFeatures = this._getOrderedFeatures(features, layers[i].layer.get("uid"));
                let hoverLayer = this.hoverHolder.layers[layers[i].layer.get("uid")];
                if (layerFeatures.length > 0) {
                    if (hoverLayer == null || !this._isLayerVisible(pixel, hoverLayer.layer)) {
                        break;
                    }
                    hit = true;
                    let feature = layerFeatures[0];

                    if (hoverLayer.layer instanceof WebGLLayer && feature.getGeometry().getType() == 'Polygon') {
                        let mapCoordinate = this.map.getCoordinateFromPixelInternal(pixel);
                        layerFeatures = this._getOrderedFeatures(hoverLayer.layer.getSource().getFeaturesAtCoordinate(mapCoordinate), layers[i].layer.get("uid"));
                        if (layerFeatures.length > 0) {
                            feature = layerFeatures[0];
                        }
                    }

                    this.map.getViewport().style.cursor = 'pointer';
                    let fid = feature.getProperties()[hoverLayer.idField];

                    if (feature.get('xstate') != styleTypes.SELECT_STYLE_TYPE && feature.get('xstate') != styleTypes.HOVER_STYLE_TYPE) {
                        this._clearAllHovered();
                        hoverLayer.features = {};
                        hoverLayer.features[fid] = feature;

                        feature.set('xstate', styleTypes.HOVER_STYLE_TYPE);

                        if (this.hasHoverTooltip) {
                            this._hideTooltip();
                            this._storeTooltip(hoverLayer.layer, hoverLayer.idField, feature, hoverLayer.tooltip, evt.pixel);

                            if (!(this.isTooltipHidden && fid in hoverLayer.features)) {
                                this._showTooltip(feature, hoverLayer.tooltip, evt.pixel, hoverLayer.layer.get('interpretation'));
                            }
                        }

                        break;
                    } else if (hoverLayer.features[fid] != null) {
                        break;
                    }
                }
            }

            if (!hit) {
            this.map.getViewport().style.cursor = 'inherit';
                if (this.hasHoverTooltip) {
                    this._hideTooltip();
                }
                this._clearAllHovered();
            }
        }
    }

    getSelectedFeatureDetails(layerId, featureId) {
        var selectionLayer = this.selectionHolder.layers[layerId];

        if (selectionLayer != null) {
            var feature = selectionLayer.features[featureId];
            if (feature != null) {
                if (Object.keys(feature).length > 0) {
                    // this means the selection was made by user input

                    return feature;
                }
                //TODO
                //else if (selectionLayer.layer.get('temporary') != null && selectionLayer.layer.get('temporary') == true) {
                //    // this means the selection was made programmatically and the layer is temporary

                //    var features = selectionLayer.layer.getSource().features;
                //    for (var i = 0; i < features.length; i++) {
                //        if (features[i].get(selectionLayer.idField) == featureId) {
                //            selectionLayer.features[featureId] = features[i];
                //            return features[i];
                //        }
                //    }
                else {
                    // this means the selection was made programmatically

                    var fullFeature = this.featureHandler.requestFeature(layerId, featureId);
                    selectionLayer.features[featureId] = fullFeature;
                    return fullFeature;
                }
            }
            throw "Feature not found";
        }
        throw "Layer not found";
    }

    getSelectedFeatures() {
        var layerId = null;
        var layerIds = Object.keys(this.selectionHolder.layers);
        for (var i = 0; i < layerIds.length; i++) {
            if (Object.keys(this.selectionHolder.layers[layerIds[i]].features).length > 0) {
                layerId = layerIds[i];
                break;
            }
        }

        if (layerId == null) {
            return null;
        }

        var features = this.getAllSelectedFeatureDetails(layerId);
        return {
            layerId: layerId,
            selectedFeatures: features
        }

    }

    getSelectedFeaturesDetails(layerId, featureIds) {
        let selectionLayer = this.selectionHolder.layers[layerId];
        let result = [];

        if (selectionLayer != null) {
            let remaining = [];

            let existing = selectionLayer.layer.getSource().getFeatures();
            let idField = selectionLayer.layer.get("idField");
            featureIds.forEach(featureId => {
                let feature = selectionLayer.features[featureId];

                if (feature != null && Object.keys(feature).length > 0) {
                    result.push(feature);
                } else {
                    let found = existing.find(x => x.get(idField) == featureId);

                    if (found) {
                        result.push(found);
                    } else {
                        remaining.push(featureId);
                    }
                }
            });

            if (remaining.length > 0) {
                if (remaining.length == 1) {
                    let fullFeature = this.featureHandler.requestFeature(layerId, remaining[0]);
                    if (fullFeature) {
                        result.push(fullFeature);
                    }
                } else {
                    let remainingFeatures = this.featureHandler.requestFeatures(layerId, remaining);

                    remainingFeatures.forEach(feature => {
                        result.push(feature);
                    });
                }
            }

            if (result.length == 0) {
                throw "No feature found";
            }

            return result;
        }
        throw "Layer not found";
    }

    getAllSelectedFeatureDetails(layerId) {
        var selectionLayer = this.selectionHolder.layers[layerId];

        if (selectionLayer != null) {
            var keys = Object.keys(selectionLayer.features);
            if (keys.length == 0) {
                return [];
            } else {
                var result = [];
                for (var i = 0; i < keys.length; i++) {
                    var currentFeature = selectionLayer.features[keys[i]];
                    if (Object.keys(currentFeature).length > 0) {
                        result.push(currentFeature);
                    }
                    else {
                        try {
                            var currentFullFeature = this.featureUtils.requestFeature(layerId, keys[i]);
                            selectionLayer.features[keys[i]] = currentFullFeature;
                            result.push(currentFullFeature);
                        } catch (err) {
                            // nothing to do here
                        }
                    }
                }
                return result;
            }
        }
        throw "Layer not found";
    }

    clearSelection() {
        this.tooltip = null;
        this._hideTooltip();
        this._clearAllSelected();
    }

    deselectAll(layerId) {
        this.tooltip = null;
        this._hideTooltip();
        let layer = this.selectionHolder.layers[layerId];
        this._clearLayerSelection(layer);

        $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: null, layerId: null }, this, this.classId);
    }

    _clearAllSelectedExcept(except) {
        let layerIds = Object.keys(this.selectionHolder.layers);

        layerIds.forEach(layerId => {
            if (except.layer.get('uid') != layerId) {
                let layer = this.selectionHolder.layers[layerId];
                this._clearLayerSelection(layer);
            }
        });
    }

    _clearAllSelected() {
        let layerIds = Object.keys(this.selectionHolder.layers);

        layerIds.forEach(layerId => {
            let layer = this.selectionHolder.layers[layerId];
            this._clearLayerSelection(layer);
        });

        $event.notify(eventTypes.FEATURE_SELECTION_CHANGED, { features: null, layerId: null }, this, this.classId);
    }

    _clearLayerSelection(layer) {
        let fids = Object.keys(layer.features);
        fids.forEach(fid => {
            if (layer.features[fid] && layer.features[fid].set) {
                layer.features[fid].set('xstate', styleTypes.DEFAULT_STYLE_TYPE);
            }
        });

        layer.features = {};
    }

    _clearAllHovered() {
        let layerIds = Object.keys(this.hoverHolder.layers);

        layerIds.forEach(layerId => {
            let layer = this.hoverHolder.layers[layerId];
            this._clearLayerHover(layer);
        });
    }

    _clearLayerHover(layer) {
        let fids = Object.keys(layer.features);
        fids.forEach(fid => {
            if (layer.features[fid].get('xstate') != styleTypes.SELECT_STYLE_TYPE) {
                layer.features[fid].set('xstate', styleTypes.DEFAULT_STYLE_TYPE);
            }
        });

        layer.features = {};
    }

    _getOrderedHoverLayers() {
        let result = [];
        let keys = Object.keys(this.hoverHolder.layers);

        for (let i = 0; i < keys.length; i++) {
            let layer = this.hoverHolder.layers[keys[i]];

            if (layer.layer.getProperties().visible && layer.active) {
                result.push(layer);
            }
        }

        return result.sort((a, b) => (a.layer.getProperties().zIndex < b.layer.getProperties().zIndex) ? 1 : ((b.layer.getProperties().zIndex < a.layer.getProperties().zIndex) ? -1 : 0));
    }

    _getOrderedFeatures(features, layerId) {
        var result = [];

        for (let i = 0; i < features.length; i++) {
            if (features[i].layerId == layerId) {
                result.push(features[i]);
            }
        }

        if (result.length > 1 && result[0].getGeometry().getType() == 'Polygon') {
            result.sort((a, b) => {
                var aArea = a.getGeometry().getArea ? a.getGeometry().getArea() : 0;
                var bArea = b.getGeometry().getArea ? b.getGeometry().getArea() : 0;

                return aArea - bArea;
            });
        }

        return result;
    }

    _getLayerById(id) {
        var layers = this.map.getLayers().getArray();
        for (var i = 0; i < layers.length; i++) {
            if (layers[i].get("uid") == id) {
                return layers[i];
            }
        }
        return null;
    }

    _isLayerVisible(pixel, targetLayer) {
        const layers = this.map
            .getAllLayers()
            .filter(l => l.getVisible())
            .sort((a, b) => (b.getZIndex() || 0) - (a.getZIndex() || 0));

        for (const layer of layers) {
            if (layer !== targetLayer) {
                if (typeof layer.getData === 'function') {
                    let data;
                    try {
                        data = layer.getData(pixel);
                    } catch (e) {
                        continue;
                    }
                    if (data && data[3] !== 0) {
                        const type = layer.get('interpretation');
                        if (type === 'WMTS' || type === 'WMS' || type === 'IMAGE_TILE') {
                            return false;
                        }
                    }
                }
                continue;
            } else {
                return true;
            }
        }

        return false;
    }

    limitPointerMoveEvents(callback) {
        let lastExecutionTime = 0;
        const interval = 1000 / 100;

        return function (event) {
            const currentTime = Date.now();

            if (currentTime - lastExecutionTime >= interval) {
                lastExecutionTime = currentTime;
                callback(event);
            }
        };
    }
}